import styled from 'styled-components'

export const HeadingContainer = styled.div`
  margin-bottom: 24px;
`

export const ScrollContainer = styled.div`
  border: 1px solid #e3e6e8;
  border-radius: 4px;
  padding: 24px;
  max-height: 400px;
  overflow-y: auto;
`

export const DisclaimerContainer = styled.div`
  margin-top: 24px;
`

export const StackViewContainer = styled.div`
  margin-top: 24px;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
`
